/**
 * @module framework/directives/sanitize-html
 */

import { Directive, DirectiveBinding } from 'vue';
import DOMPurify from 'dompurify';

import { App } from '~/framework/vue';

export const sanitizeHtmlDirective: Directive<HTMLElement> = {
    beforeMount(el, binding) {
        applySanitization(el, binding);
    },
    updated(el, binding) {
        applySanitization(el, binding);
    }
}

// Register a global custom directive called `v-sanitize-html`
export const sanitizeHtml = (app: App) => {
    app.directive('sanitize-html', sanitizeHtmlDirective);
};

function applySanitization (el: HTMLElement, binding: DirectiveBinding<string>) {
    const decodedHtml = decodeHtml(binding.value);
    el.innerHTML = DOMPurify.sanitize(decodedHtml);
}

function decodeHtml(html: string) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
}